import "./index.css";
import { Div, TituloGroup } from "../../Styles/Styled";
import { Colors, VIEW_GRUPO2 } from "../../config";
import { useEffect, useState } from "react";
import { ContainerGrupoNv2 } from "./styles";

interface IListGroups {
  items: string[];
  groupsnv2: any[];
  fixed: boolean;
  groups?: any[];
}

const width = window.innerWidth;

export default function ListGroups(props: IListGroups) {
  const [groupSelect, setGroupSelect] = useState<any>("");

  const GoToGroup = (id: string) => {
    const element = document.getElementById(`${id}`);
    if (!element) return;
    const teste = findOffset(element);
    window.scrollTo({ top: teste.top - 220, behavior: "smooth" });
  };

  function findOffset(element: any) {
    var top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);
    return {
      top: top,
      left: left,
    };
  }

  const renderGrupo2Items = (group: any, len: number) => {
    return (
      <div
        onClick={() => {
          GoToGroup(group);
        }}
        key={group + len}
        style={{
          backgroundColor: props.fixed ? "" : Colors.groupBackgroundColorNv2,
          marginLeft: 10,
          border: props.fixed ? "2px solid #edde3b" : "",
          marginRight: 10,
          padding: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 5,
          minWidth: 120,
          width: "auto",
          boxShadow: "4px -5px 38px -14px rgba(0,0,0,0.75)",
        }}
      >
        <span
          style={{
            color: Colors.groupColorTextNv2,
            fontSize: "0.80em",
            textAlign: "center",
          }}
        >
          {group}
        </span>
      </div>
    );
  };

  const renderGrupo2 = () => {
    if (groupSelect) {
      if (!props.groupsnv2[groupSelect]) return undefined;
      if (!props.groupsnv2[groupSelect][0]) {
        GoToGroup(groupSelect);
        setGroupSelect("");
        return undefined;
      }
      return props.groupsnv2[groupSelect].map((e: any, len: number) =>
        renderGrupo2Items(e, len)
      );
    } else {
      return undefined;
    }
  };

  useEffect(() => {
    console.log(props.groupsnv2);
  }, [props.groupsnv2]);

  return (
    <Div id="Categorias">
      {!props.fixed && <TituloGroup> CATEGORIAS </TituloGroup>}

      <div
        className={props.fixed ? "containerCategorias2" : "containerCategorias"}
        style={props.items.length * 200 > width ? {} : { overflowX: "hidden" }}
      >
        {props.items.map((group, index) => {
          return (
            <div
              onClick={() => {
                if (VIEW_GRUPO2 && !props.fixed) {
                  setGroupSelect(group);
                } else {
                  GoToGroup(group);
                }
              }}
              key={group + index}
              style={{
                backgroundColor: props.fixed ? "" : Colors.groupBackgroundColor,
                marginLeft: 10,
                border: props.fixed ? "2px solid #edde3b" : "",
                marginRight: 10,
                padding: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 5,
                minWidth: 120,
                width: "auto",
                boxShadow: "4px -5px 38px -14px rgba(0,0,0,0.75)",
              }}
            >
              <span
                style={{
                  color: Colors.groupColorText,
                  fontSize: "0.80em",
                  textAlign: "center",
                }}
              >
                {group}
              </span>
            </div>
          );
        })}
      </div>

      {groupSelect && !props.fixed && (
        <ContainerGrupoNv2
          colorBar={Colors.ScrollNv2}
          style={{ marginTop: 15 }}
        >
          {renderGrupo2()}
        </ContainerGrupoNv2>
      )}
    </Div>
  );
}
